export default "__VITE_ASSET__Dpl1jyKh__"